import { render, staticRenderFns } from "./DetSolicitudForm.vue?vue&type=template&id=1f09e490"
import script from "./DetSolicitudForm.vue?vue&type=script&lang=js"
export * from "./DetSolicitudForm.vue?vue&type=script&lang=js"
import style0 from "./DetSolicitudForm.vue?vue&type=style&index=0&id=1f09e490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports